module.exports = __webpack_public_path__ + "static/img/application2-1.8ef808d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application2-1.jpg
// module id = ROMN
// module chunks = 0